let investigationHistoryListScrollTop = 0;

/**
 * Returns the persisted scroll offset for the investigation history list.
 */
export const getInvestigationHistoryListScrollTop = (): number =>
  investigationHistoryListScrollTop;

/**
 * Persists the scroll offset for the investigation history list so route
 * transitions between detail pages do not reset scroll position. The new
 * investigation page clears this offset so the list starts at the top.
 */
export const setInvestigationHistoryListScrollTop = (
  scrollTop: number
): void => {
  investigationHistoryListScrollTop = Math.max(0, scrollTop);
};
